import { render, staticRenderFns } from "./FootIndex.vue?vue&type=template&id=a0f69150&scoped=true"
import script from "./FootIndex.vue?vue&type=script&lang=js"
export * from "./FootIndex.vue?vue&type=script&lang=js"
import style0 from "./FootIndex.vue?vue&type=style&index=0&id=a0f69150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f69150",
  null
  
)

export default component.exports